import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Play, Trash, CaretUp, CaretDown, YoutubeLogo, FilmStrip, Queue } from "@phosphor-icons/react";

export default function Playlist({ room, onRoom }) {
  const items = room?.playlist || [];

  const call = async (fn) => {
    try { const { data } = await fn(); if (data.room) onRoom(data.room); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  const play = (id) => call(() => api.post("/watch/playlist/play", { item_id: id }));
  const remove = (id) => call(() => api.delete(`/watch/playlist/${id}`));
  const move = (idx, dir) => {
    const order = items.map((i) => i.id);
    const j = idx + dir;
    if (j < 0 || j >= order.length) return;
    [order[idx], order[j]] = [order[j], order[idx]];
    call(() => api.post("/watch/playlist/reorder", { order }));
  };

  return (
    <div className="glass-card p-4" data-testid="watch-playlist">
      <h3 className="font-heading font-semibold text-sm mb-2 flex items-center gap-1.5">
        <Queue size={15} weight="duotone" />Плейлист серий
        <span className="text-xs text-muted-foreground num ml-auto">{items.length}</span>
      </h3>
      {items.length === 0 && (
        <p className="text-[11px] text-muted-foreground">Добавьте ссылки кнопкой «В очередь» или загрузите файлы — серии будут переключаться автоматически.</p>
      )}
      <div className="space-y-1">
        {items.map((it, idx) => {
          const current = room.current_item === it.id;
          return (
            <div key={it.id} data-testid={`playlist-item-${idx}`}
              className={`flex items-center gap-1.5 rounded-lg px-2 py-1.5 text-sm group ${current ? "bg-primary/15 ring-1 ring-primary/30" : "hover:bg-white/5"}`}>
              {it.kind === "youtube" ? <YoutubeLogo size={14} className="text-red-400 shrink-0" weight="fill" />
                : <FilmStrip size={14} className="text-muted-foreground shrink-0" weight="duotone" />}
              <button onClick={() => play(it.id)} data-testid={`playlist-play-${idx}`}
                className="flex-1 text-left truncate hover:text-primary transition-colors" title={it.title}>
                <span className="text-muted-foreground num mr-1">{idx + 1}.</span>{it.title}
              </button>
              {current && <Play size={12} weight="fill" className="text-primary shrink-0" />}
              <div className="flex opacity-0 group-hover:opacity-100 transition-opacity shrink-0">
                <button onClick={() => move(idx, -1)} className="p-0.5 text-muted-foreground hover:text-foreground" data-testid={`playlist-up-${idx}`}><CaretUp size={13} /></button>
                <button onClick={() => move(idx, 1)} className="p-0.5 text-muted-foreground hover:text-foreground" data-testid={`playlist-down-${idx}`}><CaretDown size={13} /></button>
                <button onClick={() => remove(it.id)} className="p-0.5 text-muted-foreground hover:text-red-400" data-testid={`playlist-remove-${idx}`}><Trash size={13} /></button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
